module.exports = __webpack_public_path__ + "img/SpawnerManagerSpawned.537f419e.png";